import {createFileRoute, Outlet} from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/admin/organizations')({
    component: AdminOrganizationsLayout,
})

function AdminOrganizationsLayout() {
    return <Outlet />
}
